/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ElectronSetRequiredFeaturesResult } from './ElectronSetRequiredFeaturesResult';
import {
    ElectronSetRequiredFeaturesResultFromJSON,
    ElectronSetRequiredFeaturesResultFromJSONTyped,
    ElectronSetRequiredFeaturesResultToJSON,
    ElectronSetRequiredFeaturesResultToJSONTyped,
} from './ElectronSetRequiredFeaturesResult';

/**
 * 
 * @export
 * @interface CreateElectronInstallSnapshotRequestBody
 */
export interface CreateElectronInstallSnapshotRequestBody {
    /**
     * 
     * @type {string}
     * @memberof CreateElectronInstallSnapshotRequestBody
     */
    sessionId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateElectronInstallSnapshotRequestBody
     */
    electronVersion: string;
    /**
     * 
     * @type {string}
     * @memberof CreateElectronInstallSnapshotRequestBody
     */
    sdkVersion: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateElectronInstallSnapshotRequestBody
     */
    supportedGameIds: Array<number>;
    /**
     * 
     * @type {Array<ElectronSetRequiredFeaturesResult>}
     * @memberof CreateElectronInstallSnapshotRequestBody
     */
    setRequiredFeaturesResults: Array<ElectronSetRequiredFeaturesResult>;
    /**
     * 
     * @type {number}
     * @memberof CreateElectronInstallSnapshotRequestBody
     */
    reportedAt?: number;
}

/**
 * Check if a given object implements the CreateElectronInstallSnapshotRequestBody interface.
 */
export function instanceOfCreateElectronInstallSnapshotRequestBody(value: object): value is CreateElectronInstallSnapshotRequestBody {
    if (!('sessionId' in value) || value['sessionId'] === undefined) return false;
    if (!('electronVersion' in value) || value['electronVersion'] === undefined) return false;
    if (!('sdkVersion' in value) || value['sdkVersion'] === undefined) return false;
    if (!('supportedGameIds' in value) || value['supportedGameIds'] === undefined) return false;
    if (!('setRequiredFeaturesResults' in value) || value['setRequiredFeaturesResults'] === undefined) return false;
    return true;
}

export function CreateElectronInstallSnapshotRequestBodyFromJSON(json: any): CreateElectronInstallSnapshotRequestBody {
    return CreateElectronInstallSnapshotRequestBodyFromJSONTyped(json, false);
}

export function CreateElectronInstallSnapshotRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateElectronInstallSnapshotRequestBody {
    if (json == null) {
        return json;
    }
    return {
        
        'sessionId': json['sessionId'],
        'electronVersion': json['electronVersion'],
        'sdkVersion': json['sdkVersion'],
        'supportedGameIds': json['supportedGameIds'],
        'setRequiredFeaturesResults': ((json['setRequiredFeaturesResults'] as Array<any>).map(ElectronSetRequiredFeaturesResultFromJSON)),
        'reportedAt': json['reportedAt'] == null ? undefined : json['reportedAt'],
    };
}

export function CreateElectronInstallSnapshotRequestBodyToJSON(json: any): CreateElectronInstallSnapshotRequestBody {
    return CreateElectronInstallSnapshotRequestBodyToJSONTyped(json, false);
}

export function CreateElectronInstallSnapshotRequestBodyToJSONTyped(value?: CreateElectronInstallSnapshotRequestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sessionId': value['sessionId'],
        'electronVersion': value['electronVersion'],
        'sdkVersion': value['sdkVersion'],
        'supportedGameIds': value['supportedGameIds'],
        'setRequiredFeaturesResults': ((value['setRequiredFeaturesResults'] as Array<any>).map(ElectronSetRequiredFeaturesResultToJSON)),
        'reportedAt': value['reportedAt'],
    };
}

